import React, { Component } from 'react';
import PropTypes from 'prop-types';
import catchLifeCycleErrors from 'utils/catchLifeCycleErrors';
import { StandardPage } from "../../Common/pages/StandardPage";
import HorseRacingMostFollowed from "./HorseRacingMostFollowed";
import { RightColumn } from "../../Common/pages/RightColumn";
import { canonicalLink } from "../../../utils/seoUtils"

@catchLifeCycleErrors
export default class HorseRacingResultsPage extends Component {
  static propTypes = {
    routes: PropTypes.array.isRequired,
    params: PropTypes.shape({date: PropTypes.string}),
    location: PropTypes.object,
    HorseRacingRacePageContainer: PropTypes.element,
    HorseRacingResultsForDateContainer: PropTypes.element
  };

  render() {
    const {
      location,
      params,
      HorseRacingRacePageContainer,
      HorseRacingResultsForDateContainer
    } = this.props;
    const helmetProps = canonicalLink(this.props.routes, {date: params.date});

    return (
      <StandardPage sport="racing" title="Racecards" helmetProps={helmetProps}>
        <div className="main-layout-left-column">
          { HorseRacingRacePageContainer }
          { HorseRacingResultsForDateContainer }

          <div id="left-most-read" className="main-layout-block last-handheld main-layout-hide-desktop">
            <HorseRacingMostFollowed location={location} plainTitle />
          </div>
        </div>

        <RightColumn location={location}
                     sport="racing"
                     content={
                       ["topMpu", "horseRacingNextRaceOffAll", "racingTips", "bottomMpu", "ocWidget", "horseRacingMostFollowed"]} />
      </StandardPage>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/containers/HorseRacingResultsPage.js